import { render, staticRenderFns } from "./BussinessAccountEditor.vue?vue&type=template&id=c33da852&scoped=true"
import script from "./BussinessAccountEditor.vue?vue&type=script&lang=js"
export * from "./BussinessAccountEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33da852",
  null
  
)

export default component.exports